"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentForm = void 0;
var react_1 = __importDefault(require("react"));
var getFormName = function (uuid) { return "parent-".concat(uuid); };
var CommentForm = function (props) {
    var commentForm = props.commentForm, toggleReplyForm = props.toggleReplyForm, onCommentSubmit = props.onCommentSubmit, _a = props.commentUUID, commentUUID = _a === void 0 ? null : _a;
    if (!commentForm)
        return null;
    return react_1.default.cloneElement(commentForm, {
        onCancel: toggleReplyForm,
        onSubmit: onCommentSubmit,
        form: getFormName(commentUUID),
    });
};
exports.CommentForm = CommentForm;
exports.default = exports.CommentForm;
